import React from "react";
import defStyles from "./Button.module.scss";
import nomadStyles from "./Button.nomad.module.scss";

const styles =
  process.env.REACT_APP_BRAND === "nomad" ? nomadStyles : defStyles;

interface ButtonProps {
  title?: string;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  size?: "large" | "medium" | "small";
  variant?: "primary" | "dark" | "light" | "disabled";
  wide?: boolean;
  children?: React.ReactNode;
  rounded?: boolean
}

export const Button: React.FC<ButtonProps> = ({
  title,
  onClick,
  disabled = false,
  className,
  size = "medium",
  variant = "primary",
  wide = false,
  children,
  rounded = false
}) => {
  const colorClass = variant ? styles[variant] : styles.primary;
  const sizeClass = size ? styles[size] : styles.medium;
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (onClick && !disabled) {
      onClick();
    }
  };

  return (
    <button
      className={`${styles.btn} ${rounded && styles.rounded} ${sizeClass} ${colorClass} ${wide && styles.wide} ${className || ""} ${disabled && styles.disabled}`}
      onClick={handleClick}
      disabled={disabled}
      type="button"
      aria-disabled={disabled}
    >
      {title}
      {children}
    </button>
  );
};
